const main = document.querySelector("main[data-template='index']");

if (main && !window.ghHomeDtcAnimationsReady) {
  window.ghHomeDtcAnimationsReady = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.body.classList.add('gh-home-dtc');

  const hero = main.querySelector('.gh-shopping');
  hero?.classList.add('gh-home-hero');

  requestAnimationFrame(() => {
    requestAnimationFrame(() => document.body.classList.add('gh-home-dtc-ready'));
  });

  const revealTargets = [
    ...main.querySelectorAll(
      [
        '.section-resource-list__header .text-block',
        '.section-resource-list__header a',
        '.serbal-editorial img',
        '.serbal-values > *',
        '.gh-shopping__faq > *',
      ].join(',')
    ),
  ];

  revealTargets.forEach((element, index) => {
    if (!(element instanceof HTMLElement) || element.closest('.gh-home-hero')) return;
    element.dataset.ghHomeReveal = element.matches('img') ? 'image' : 'fade';
    element.style.setProperty('--gh-home-order', String(index % 4));
  });

  if (!reducedMotion) {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-gh-home-reveal-visible', 'true');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    revealTargets.forEach((element) => {
      if (element instanceof HTMLElement && element.dataset.ghHomeReveal) revealObserver.observe(element);
    });
  } else {
    revealTargets.forEach((element) => element.setAttribute('data-gh-home-reveal-visible', 'true'));
  }

  const marqueeObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        entry.target.setAttribute('data-gh-marquee-active', String(entry.isIntersecting));
      });
    },
    { threshold: 0.05 }
  );

  main.querySelectorAll('marquee-component').forEach((marquee) => marqueeObserver.observe(marquee));

  const endCta = document.createElement('section');
  endCta.className = 'gh-home-end-cta';
  endCta.dataset.ghHomeReveal = 'fade';
  const isArabic = document.documentElement.lang.startsWith('ar') || window.location.pathname.startsWith('/ar/');
  endCta.innerHTML = `
    <p class="gh-home-end-cta__eyebrow">${isArabic ? 'اختيارات غلوريا' : 'The Ghlorya edit'}</p>
    <h2 class="gh-home-end-cta__title">${isArabic ? 'اكتشفي عبايتك القادمة' : 'Discover your next abaya'}</h2>
    <a class="gh-home-end-cta__link" href="${isArabic ? '/ar/collections/all' : '/collections/all'}">${isArabic ? 'استكشفي جميع العبايات' : 'Explore all abayas'}</a>
  `;
  main.append(endCta);

  if (!reducedMotion) {
    const endCtaObserver = new IntersectionObserver(
      ([entry], observer) => {
        if (!entry?.isIntersecting) return;
        endCta.setAttribute('data-gh-home-reveal-visible', 'true');
        observer.disconnect();
      },
      { threshold: 0.2 }
    );
    endCtaObserver.observe(endCta);
  } else {
    endCta.setAttribute('data-gh-home-reveal-visible', 'true');
  }

}
